module.exports = __webpack_public_path__ + "img/mortgage.64c6931f.svg";